<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container" id="customers">
        <page-title :routeProps="routeProps"></page-title>
        <div class="vertical-center-container text-xs-right">
          <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
            <v-icon>playlist_add</v-icon>
          </v-btn>
        </div>
        <!-- <v-btn flat color="grey" @click="toggleView()">         
                    <v-icon left v-if="listView">list</v-icon>
                    <v-icon left v-else>view_module</v-icon>
                    View
        </v-btn>-->
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 lg3>
          <div class="flex-container-space-between">
            <!-- <v-autocomplete
                        label="Project"
                        :prepend-icon="$store.state.global.pages.project.icon"
                        :color="$store.state.global.pages.project.color"
                        :items="projects"
                        v-model="project"
                        item-text="projectName_clientName"
                        :clearable="true"
                        item-value="id">
            </v-autocomplete>-->
            <v-autocomplete
              label="Site"
              :prepend-icon="$store.state.global.pages.site.icon"
              :color="$store.state.global.pages.site.color"
              :items="sites"
              v-model="site"
              item-text="siteName_projectName"
              :clearable="true"
              item-value="id"
            ></v-autocomplete>
            <div class="ml-3" v-if="!!project">
              <v-switch
                :color="$store.state.global.pages.project.color"
                label="Details"
                v-model="showDetails"
              ></v-switch>
            </div>
          </div>
        </v-flex>

        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
        <!-- <v-btn dark :color="routeProps.color" @click="pdf">
                        Create report
        </v-btn>-->

        <!--CONTROL INFO DISPLAY -->
        <control-info-display :data="projectObj" route="project" v-model="showDetails"></control-info-display>
        <!-- <report-filter></report-filter> -->
      </layout-no-padding>
      <v-dialog
        v-model="addRateDialog"
        max-width="800px"
        @keydown.esc="addRateDialog = false"
        v-if="userAuthClass"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-rate" slot="activator">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- ADD RATE COMPONENT-->
        <add-rate @close="addRateDialog = false"></add-rate>
      </v-dialog>

      <card-divider-split></card-divider-split>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
    <filter-drawer></filter-drawer>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";
import ProjectService from "@/services/requests/projectService";
import RateValidation from "@/services/validation/rateValidation";
import AddRate from "@/components/rates/addRate";
import ReportFilter from "@/components/rates/reportFilter";
import ControlInfoDisplay from "@/components/ui/controlInfoDisplay";
import RouteProps from "@/services/mixins/routeProps";
import FilterDrawer from "@/components/trips/filterDrawer";
import getSites from "@/services/mixins/getMasterFiles/getSites";

export default {
  mixins: [RateValidation, RouteProps, getSites],
  data() {
    return {
      addRateDialog: false,
      sortFactors: [
        {
          value: "id",
          text: "ID"
        },
        {
          value: "name",
          text: "Name"
        },
        {
          value: "updatedAt",
          text: "Updated At"
        }
      ]
    };
  },
  methods: {
    getProjects() {
      ProjectService.getAllProjects()
        .then(result => {
          //console.log(result);
          this.projects = result.data.result;
          this.$store.commit("projects/setState", {
            prop: "loadingProjects",
            value: false
          });
        })
        .catch(err => {
          this.$store.commit("projects/setState", {
            prop: "loadingProjects",
            value: false
          });
          // this.$store.commit("projects/modifyLoadingProjects", false);
          this.snackError();
          console.log(err);
        });
    },
    toggleView() {
      this.listView = !this.listView;
    },
    sortRates(path1, path2) {
      return this.rates.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1;
        } else {
          return 1;
        }
      });
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "rates", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "rates", prop: "filterBy" }),
    listView: Store.getSet({ store: "rates", prop: "listView" }),
    rates: Store.getSet({ store: "rates", prop: "rates" }),
    projects: Store.getSet({ store: "projects", prop: "projects" }),
    project: Store.getSet({ store: "rates", prop: "project" }),
    drawer: Store.getSet({ store: "shared", prop: "drawer" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    showInactive: Store.getSet({ store: "shared", prop: "showInactive" }),
    site: Store.getSet({ store: "rates", prop: "site" }),
    showDetails: Store.getSet({ store: "rates", prop: "showDetails" }),

    projectObj() {
      if (!!this.project) {
        return this.getObjByPrimaryId(this.project, this.projects);
      } else {
        return null;
      }
    }
  },
  mounted() {
    this.getProjects();
  },
  destroy() {
    this.$store.commit("rates/resetRates");
  },
  components: {
    AddRate,
    ReportFilter,
    ControlInfoDisplay,
    FilterDrawer
  },
  watch: {
    projectObj(val) {
      if (!!val) {
        this.showDetails = true;
      } else {
        this.showDetails = false;
      }
    }
  }
};
</script>

<style scoped>
.overlap-fab-rate {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>


